<template>
  <div class="container">
    <div class="svgDetailContainer" :class="showClass">
      <div class="svgContainer">
        <div class="chart" ref="sunburstChart"></div>
      </div>
      <v-dialog
          transition="dialog-bottom-transition"
          width="95%"
          v-model="detailContentShow"
          :persistent="votingInProgress == true">
        <template v-slot:default>
          <v-card class="detailCard">
            <v-toolbar
                :style="{backgroundColor: selectedSegment.data.color}"
                :title="selectedSegment.data.text[lang].name"
            >
              <span style="margin-right: 20px" v-if="votingInProgress == true && votingEnded == false">{{votes.length}}/{{users.length}} Votes</span>
            </v-toolbar>
            <div class="detailCardContainer">
              <div v-if="votingEnded == false">
                <div class="font-weight-black">Description:</div>
                <div>{{selectedSegment.data.text[lang].description}}</div>
                <div class="font-weight-black">Example:</div>
                <div>{{selectedSegment.data.text[lang].example}}</div>
              </div>
              <div style="position: relative">
                <div v-if="votingInProgress == true && votingEnded == false" ref="divider" class="divider-area text-center">
                  <span ref="dividerButton" class="divider-button-container">
                    <span class="divider-button">
                      {{ timeString }}
                    </span>
                  </span>
                </div>
                <div class="titleCardContainer" v-if="votingEnded == true" >Where we want to be</div>
                <div id="cardDataWantToBe" key="cardDataWantToBe" class="cards-row" v-if="votingEnded == true" >
                  <v-card  v-for="(card, index) in cardDataWantToBe" :key="'cardDataWantToBe'+index" class="card" elevation="2" :class="{'selected-card': selectedVotingValue != undefined && selectedVotingValue.value === card.value}" @click="selectVotingValue(card)">
                    <v-card-title class="card-headline">{{ card.visualValue }}</v-card-title>
                    <div class="card-divider"></div>
                    <v-card-text class="card-text">{{ card.text[lang].description }}</v-card-text>
                    <div class="card-divider"></div>
                    <v-card-text class="card-vote">
                      <div class="number">{{ card.voteCount }} Votes</div>
                      <v-tooltip
                          activator="parent"
                          location="start"
                      >Tooltip</v-tooltip>
                    </v-card-text>
                  </v-card>
                </div>
                <div class="titleCardContainer" v-if="votingEnded == true" >Where we are</div>
                <div id="cardDataWhereWeAre" key="cardDataWhereWeAre" class="cards-row" v-if="votingEnded == true" >
                  <v-card  v-for="(card, index) in cardDataWhereWeAre" :key="'cardDataWhereWeAre'+index" class="card" elevation="2" :class="{'selected-card': selectedVotingItsOnValue != undefined && selectedVotingItsOnValue.value === card.value}" @click="selectVotingItsOnValue(card)">
                    <v-card-title class="card-headline">{{ card.visualValue }}</v-card-title>
                    <div class="card-divider"></div>
                    <v-card-text class="card-text">{{ card.text[lang].description }}</v-card-text>
                    <div class="card-divider"></div>
                    <v-card-text class="card-vote">
                      <div class="number">{{ card.voteCount }} Votes</div>
                      <v-tooltip
                          activator="parent"
                          location="start"
                      >Tooltip</v-tooltip>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
              <div class="detailButtons">
                <v-btn v-if="started == true && votingInProgress == false && selectedSegment.depth > 1" @click="startSegmentVoting()">Start Voting</v-btn>
                <v-btn v-if="votingInProgress == true && votingEnded == false" @click="addTime">+2:00</v-btn>
                <v-btn v-if="votingInProgress == true" @click="cancelVoting">Cancel</v-btn>
                <v-btn v-if="votingInProgress == true && votingEnded == false" @click="endVoting">End</v-btn>
                <v-btn v-if="votingInProgress == true && votingEnded == true" @click="reVoting">Re-Vote</v-btn>
                <v-btn v-if="votingEnded == true" :disabled="selectedVotingValue == undefined || selectedVotingItsOnValue == undefined"  @click="chooseVoting">Choose</v-btn>
              </div>
            </div>
          </v-card>
        </template>
      </v-dialog>
    </div>

    <v-btn icon="mdi-play" class="startButton" v-if="started == false" @click="startWorkshop"></v-btn>
    <v-btn icon="mdi-skip-forward" class="stopButton" v-if="started == true" @click="stopWorkshop"></v-btn>
    <v-btn class="qrButton" icon="mdi-qrcode" v-if="started == true" @click="qrdialog = true"></v-btn>
    <v-btn icon="mdi-account" @click="userDialog=true" class="usersButton" v-if="started == true"></v-btn>
    <v-dialog
        transition="dialog-bottom-transition"
        width="70%"
        v-model="userDialog">
      <template v-slot:default>
        <v-card>
          <v-toolbar
              color="primary"
              title="Users"
          >
            <v-btn icon @click="userDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list :items="users"
                  item-title="name"
                  item-value="id">
            <template #append="item" >
              <v-btn variant="text" @click="deleteUser(item.item)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
          </v-list>
          <div style="text-align: center; font-size: 24px" v-if="users.length == 0"> NO USERS IN WORKSHOP</div>
        </v-card>
      </template>
    </v-dialog>
    <v-btn @click="filterDialog=true" class="filterButton" icon="mdi-filter"></v-btn>
    <v-dialog
        transition="dialog-bottom-transition"
        width="70%"
        v-model="filterDialog">
      <template v-slot:default>
        <v-card>
          <v-toolbar
              color="primary"
              title="Filter"
          >
            <v-btn icon @click="filterDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-radio-group v-model="showClass">
            <v-radio label="Show All" value="showAll"></v-radio>
            <v-radio label="Show where we are" value="showWhereWeAre"></v-radio>
            <v-radio label="Radio where we want to be" value="showWhereWeWantToBe"></v-radio>
          </v-radio-group>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
        transition="dialog-bottom-transition"
        width="70%"
        v-model="qrdialog">
      <template v-slot:default>
        <v-card>
          <v-toolbar
              color="primary"
              title="Join Workshop"
          >
            <v-btn icon @click="qrdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <qrcode-vue class="qrcode" v-if="workshopId != undefined" :value="getJoinUrl()" :size="400" level="H" />
          <a class="openLink" v-if="workshopId != undefined" :href="getLinkUrl()" target="_blank">Open in Browser</a>
        </v-card>
      </template>
    </v-dialog>
  </div>

</template>

<script>
import segmentData from '../data/segment.json'
import * as d3 from 'd3';
import QrcodeVue from "qrcode.vue";
import {
  deleteUser, deleteVoting, endVoting, loadWorkshop,
  onActiveVotingVotesChange,
  onUsersChange, saveVoting, setNewVotingEndTime,
  startVoting,
  startWorkshop
} from "@/workshop/workshopFunctions";
import segmentCardData from "@/data/segmentVoting.json";

export default {
  name: "workshopChart",
  components: {QrcodeVue},
  data() {
    return {
      showClass: 'showWhereWeWantToBe',
      started: false,
      userCount: 0,
      users: [],
      votes: [],
      selectedSegment: null,
      userDialog: false,
      filterDialog: false,
      detailContentShow: false,
      qrdialog: false,
      lang: 'en',
      votingInProgress:false,
      activeVoringStart:undefined,
      activeVoringEnd:undefined,
      selectedVotingValue:undefined,
      selectedVotingItsOnValue:undefined,
      votingEnded: false,
      percentTimeLeft: 100,
      timerInterval: null,
      timeString: "",
      cardDataWantToBe: JSON.parse(JSON.stringify(segmentCardData)),
      cardDataWhereWeAre: JSON.parse(JSON.stringify(segmentCardData)),
      chartdata:
          {
            name: 'root',
            children: JSON.parse(JSON.stringify(segmentData))
          }
    }
  },
  computed: {
    cardsWantToBe() {
      return this.cardDataWantToBe;
    },
    cardsWantToGo() {
      return this.cardDataWhereWeAre;
    },
    customerId() {
      return this.$route.params.customerId;
    },
    workshopId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    loadWorkshop(this.customerId, this.workshopId).then(res => {
      console.log("Res", res);
      if(res == null || res == undefined){
        this.assignProportionalValues(this.chartdata, []);
      } else {
        this.assignProportionalValues(this.chartdata, res.results);
      }

      this.drawSunburst();
    });
  },
  methods: {
    deleteUser(user){
     deleteUser(this.workshopId, user.id);
    },
    getJoinUrl(){
      const customerId = this.$store.getters.getCustomerId;
      return 'http:'+location.host +'/customer/'+customerId+'/workshop/join/'+this.workshopId+'/'+this.lang;
    },
    getLinkUrl(){
      const customerId = this.$store.getters.getCustomerId;
      return '/customer/'+customerId+'/workshop/join/'+this.workshopId+'/'+this.lang;
    },
    async startWorkshop(){
      await startWorkshop(this.workshopId);
      this.started = true;
      this.qrdialog = true;
      await onUsersChange(this.workshopId, this.userChanged);
    },
    async stopWorkshop(){
      this.$emit('stopVote')
    },
    userChanged(users){
      this.users = users;
      this.userCount = users.length;
    },
    lightenDarkenColor(col, amt) {
      var num = parseInt(col.substr(1), 16);
      var r = (num >> 16) + amt;
      var b = ((num >> 8) & 0x00FF) + amt;
      var g = (num & 0x0000FF) + amt;
      var newColor = g | (b << 8) | (r << 16);
      return "#"+newColor.toString(16);
    },
    handleSegmentClick(d) {
      const segmentId = `segment-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`;
      if (this.selectedSegment === d) {
        // Wenn das Segment bereits selektiert ist, deselektieren
        this.selectedSegment = null;
      } else {
        // Segment selektieren
        this.selectedSegment = d;
        this.detailContentShow = true;
      }
      this.updateSegmentStyles(segmentId);
    },
    updateSegmentStyles(segmentId) {
      // Entfernt vorherige Selektionen
      Array.from(document.getElementsByClassName("selected")).forEach(e => e.classList.remove("selected"))
      d3.selectAll('.selected').classed('selected', false);
      if (this.selectedSegment) {
        // Markiert das aktuell selektierte Segment
        document.getElementById(segmentId).classList.add("selected");
      }
    },
    isSelected(cat, subcat, value){
      var catdata = this.chartdata.children.filter(c => c.id == cat)[0].children.filter(c => c.id == subcat)[0];
      return catdata.value == value;
    },
    setValue(cat, subcat, value, valueItsOn, delay = 0) {
      console.log("Set Value", cat, subcat, value, valueItsOn);
      var catdata = this.chartdata.children.filter(c => c.id == cat)[0].children.filter(c => c.id == subcat)[0];
      catdata.valueWantsToBe = value;
      catdata.valueWhereWeAre = valueItsOn;
      //this.drawSunburst();

      const width = 600;
      const radius = width / 2;
      const arc = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.02)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWantsToBe || 0) * 10 + 2)
          .outerRadius(d => d.y1 + (d.data.valueWantsToBe || 0) * 10);
      const segment = document.getElementById("segment-"+cat+"-"+subcat);
      const newD = arc(catdata.d);

      const arc2 = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.02)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWhereWeAre || 0) * 10 +2)
          .outerRadius(d => d.y1 + (d.data.valueWhereWeAre || 0) * 10);

      const segmentLine = document.getElementById("segmentLine-"+cat+"-"+subcat);
      const newDLine = arc2(catdata.d);
      const colorSegmentLine = value <= valueItsOn ? 'rgba(0,131,0,0.5)' : 'rgba(173,0,0,0.5)'

      const segmentText = document.getElementById("segmentText-"+cat+"-"+subcat);
      const x = arc.centroid(catdata.d)[0];
      const y = arc.centroid(catdata.d)[1];
      const hypotenuse = Math.sqrt(x * x + y * y);
      const xNorm = x / hypotenuse;
      const yNorm = y / hypotenuse;
      const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
      const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
      const newTranslate = `translate(${arc.centroid(catdata.d)}) rotate(${rotation + additionalRotation})`;

      const segmentTextWantWeAreText = document.getElementById("segmentText2-"+cat+"-"+subcat);
      const xWantWeAreText = arc2.centroid(catdata.d)[0];
      const yWantWeAreText = arc2.centroid(catdata.d)[1];
      const hypotenuseWantWeAreText = Math.sqrt(xWantWeAreText * xWantWeAreText + yWantWeAreText * yWantWeAreText);
      const xNormWantWeAreText = xWantWeAreText / hypotenuseWantWeAreText;
      const yNormWantWeAreText = yWantWeAreText / hypotenuseWantWeAreText;
      const rotationWantWeAreText = Math.atan2(yNormWantWeAreText, xNormWantWeAreText) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
      const additionalRotationWantWeAreText = rotationWantWeAreText < -90 || rotationWantWeAreText > 90 ? -180 : 0;
      const newTranslateWantWeAreText = `translate(${arc2.centroid(catdata.d)}) rotate(${rotationWantWeAreText + additionalRotationWantWeAreText})`;



      d3.select(segment) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(1000) // Dauer der Animation in Millisekunden, z.B. 1000 ms = 1 Sekunde
          .delay(delay)
          .attr('d', newD);

      d3.select(segmentLine) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(1000) // Dauer der Animation in Millisekunden, z.B. 1000 ms = 1 Sekunde
          .delay(delay)
          .attr('d', newDLine)
          .attr('stroke', colorSegmentLine);


      d3.select(segmentText) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(1000) // Dauer der Animation in Millisekunden, z.B. 1000 ms = 1 Sekunde
          .delay(delay)
          .attr('transform', newTranslate);

      d3.select(segmentTextWantWeAreText) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(1000) // Dauer der Animation in Millisekunden, z.B. 1000 ms = 1 Sekunde
          .delay(delay)
          .attr('transform', newTranslateWantWeAreText);

    },
    assignProportionalValues(node, results) {
      let count = 0;
      const children = node.children || [];
      node.value = 0;
      children.forEach(child => {
        if (child.children != undefined && child.children != []) {
          this.assignProportionalValues(child, results)
        } else if(results != undefined && Object.keys(results).includes(child.id)) {
          child.valueWantsToBe = 0;
          child.valueWhereWeAre = 0;
          child.sizeValue = 1 / children.length;
          count = count + 1;
          setTimeout((valueWantsToBe, valueWhereWeAre)=> {
            this.setValue(node.id, child.id, valueWantsToBe, valueWhereWeAre, count*200);
          }, 0, results[child.id].voteWhereWantToBe, results[child.id].voteWhereWeAre);
        } else {
          child.valueWantsToBe = 0;
          child.valueWhereWeAre = undefined;
          child.sizeValue = 1 / children.length;
        }
      });
    },
    getParentSegmentOfActive(){
      for (const cat of segmentData) {
        for(const subcat of cat.children){
          if(subcat.id == this.selectedSegment.data.id){
            return cat;
          }
        }
      }
      return null; // Wenn die ID nicht gefunden wurde
    },
    startSegmentVoting(){
      const durationInMin = 2;
      startVoting(this.workshopId, this.selectedSegment.data.id, durationInMin);
      this.activeVoringStart = Date.now();
      this.activeVoringEnd = Date.now()+(durationInMin*60*1000);
      onActiveVotingVotesChange(this.workshopId, this.voteChange);
      this.votingEnded = false;
      this.votingInProgress = true;
      this.updatePercentTimeLeft();
      this.timerInterval = setInterval(this.updatePercentTimeLeft, 100);
    },
    voteChange(newState){
      this.votes = newState;
      this.endVotingIfAllUsersVoted();
    },
    selectVotingValue(card){
      this.selectedVotingValue = card;
    },
    selectVotingItsOnValue(card){
      this.selectedVotingItsOnValue = card;
    },
    endVotingIfAllUsersVoted(){
      if(this.votes.length == this.users.length){
        this.stopVoting();
      }
    },
    stopVoting(){
      if(this.$refs.timer != undefined) {
        this.$refs.timer.clear();
      }
      this.votingEnded = true;
      clearInterval(this.timerInterval);
      this.sortCardsOnVotings();
      endVoting(this.workshopId);
    },
    sortCardsOnVotings(){
      this.cardDataWantToBe = [...this.cardDataWantToBe.map(c => {
        c.voteCount = this.votes.filter(v => v['voteWhereWantToBe'] == c.value).length;
        return c;
      })];
      this.cardDataWantToBe.sort((x, y) => {
        // Zuerst nach 'a' absteigend sortieren
        if (x.voteCount !== y.voteCount) {
          return y.voteCount - x.voteCount;
        }
        // Wenn 'a' gleich ist, dann nach 'b' absteigend sortieren
        return x.value - y.value;
      });

      this.cardDataWhereWeAre = [...this.cardDataWhereWeAre.map(c => {
        c.voteCount = this.votes.filter(v => v['voteWhereWeAre'] == c.value).length;
        return c;
      })];
      this.cardDataWhereWeAre.sort((x, y) => {
        // Zuerst nach 'a' absteigend sortieren
        if (x.voteCount !== y.voteCount) {
          return y.voteCount - x.voteCount;
        }
        // Wenn 'a' gleich ist, dann nach 'b' absteigend sortieren
        return x.value - y.value;
      });

      console.log("this.cardDataWhereWeAre", this.cardDataWhereWeAre);
      console.log("this.cardDataWantToBe", this.cardDataWantToBe);
      console.log("this.votes", this.cardDataWantToBe);

    },
    reVoting(){
      this.startSegmentVoting();
    },
    async chooseVoting(){
      await saveVoting(this.workshopId, this.selectedSegment.data.id, this.votes, this.selectedVotingValue.value, this.selectedVotingItsOnValue.value);
      this.setValue(this.getParentSegmentOfActive().id, this.selectedSegment.data.id, this.selectedVotingValue.value, this.selectedVotingItsOnValue.value);
      this.cancelVoting();
    },
    addTime(){
      this.activeVoringEnd = this.activeVoringEnd + 2*60*1000
      setNewVotingEndTime(this.workshopId, this.activeVoringEnd);
    },
    async endVoting(){
      this.stopVoting();
    },
    cancelVoting(){
      this.votes = [];
      this.votingInProgress = false;
      this.activeVoringStart = undefined;
      this.activeVoringEnd = undefined;
      this.selectedVotingValue = undefined;
      this.selectedVotingItsOnValue = undefined;
      this.votingEnded = false;
      this.detailContentShow = false;
      this.timeString = "";
      this.percentTimeLeft = 100;
      clearInterval(this.timerInterval);
      deleteVoting(this.workshopId);
    },
    drawSunburst() {
      // Löscht das bestehende SVG, falls vorhanden, um ein neues Diagramm zu zeichnen
      this.$refs.sunburstChart.innerHTML = '';

      const width = 600;
      const radius = width / 2;

      const root = d3.partition()
          .size([2 * Math.PI, radius])(
              d3.hierarchy(this.chartdata)
                  .sum(d => d.sizeValue)
          );

      const arc = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.05)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWantsToBe || 0) * 10 +4)
          .outerRadius(d => d.y1 + (d.data.valueWantsToBe || 0) * 10);
      //.outerRadius(d => d.y1 - 1);


      const arc2 = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.05)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWhereWeAre || 0) * 10 +4)
          .outerRadius(d => d.y1 + (d.data.valueWhereWeAre || 0) * 10);

      const svg = d3.select(this.$refs.sunburstChart).append('svg')
//      const svg = d3.select(this.$refs.sunburstChart.value).append('svg')
          .attr('viewBox', `${-width / 2} ${-width / 2} ${width} ${width}`)
          .style('font', '10px sans-serif');

      const segment = svg.append('g')
          .selectAll('g')
          .data(root.descendants().filter(d => d.depth))
          .join('g');

      segment.append('path')
          .attr('class', 'segmentpart')
          .attr('fill', d => d.data.color)
          .attr('stroke', d => this.lightenDarkenColor(d.data.color, -30))
          .attr('d', arc)
          .attr('id', d => `segment-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .on('click', d => this.handleSegmentClick(d.currentTarget["__data__"]));


      segment.append('path')
          .attr('class', 'segmentLinePart')
          .attr('fill-opacity', 0)
          .attr('fill', d => d.data.color)
          .attr('stroke', d => d.data.valueWhereWeAre == undefined ? d.data.color : d.data.valueWantsToBe <= d.data.valueWhereWeAre ? 'rgba(0,131,0,0.5)' : 'rgba(173,0,0,0.5)')
          .attr('d', arc2)
          .attr('id', d => `segmentLine-${(d.depth > 1 ? d.parent.data.id + "-" : "") + d.data.id}`)
          .on('click', d => this.handleSegmentClick(d.currentTarget["__data__"]));

      segment.append('text')
          .attr('id', d => `segmentText-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .attr("transform", d => {
            d.data.d = d;
            const x = arc2.centroid(d)[0];
            const y = arc2.centroid(d)[1];
            const hypotenuse = Math.sqrt(x * x + y * y);
            const xNorm = x / hypotenuse;
            const yNorm = y / hypotenuse;
            const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
            const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
            return `translate(${arc.centroid(d)}) rotate(${rotation + additionalRotation})`;
          })
          .on('click', d => this.handleSegmentClick(d.currentTarget.parentNode["__data__"]))
          .attr("text-anchor", "middle")
          .text(d => d.data.text[this.lang].name)
          .style("fill", "#000")
          .style("font-size", "10px")
          .each(function(d) {
            const bbox = this.getBBox();
            const scale = Math.min(arc.outerRadius()(d) - arc.innerRadius()(d) / bbox.width, arc.outerRadius()(d) - arc.innerRadius()(d) / bbox.height);
            d.scale = scale > 1 ? 1 : scale;
          })
          .attr("class", "segmentpartText wantWeWantToBeText")
          .style("font-size", d => d.scale * 10 + "px")
          .attr("dy", ".35em");
      segment.append('text')
          .attr('id', d => `segmentText2-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .attr("transform", d => {
            d.data.d = d;
            const x = arc2.centroid(d)[0];
            const y = arc2.centroid(d)[1];
            const hypotenuse = Math.sqrt(x * x + y * y);
            const xNorm = x / hypotenuse;
            const yNorm = y / hypotenuse;
            const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
            const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
            return `translate(${arc2.centroid(d)}) rotate(${rotation + additionalRotation})`;
          })
          .on('click', d => this.handleSegmentClick(d.currentTarget.parentNode["__data__"]))
          .attr("text-anchor", "middle")
          .text(d => d.data.text[this.lang].name)
          .style("fill", "#000")
          .style("font-size", "10px")
          .each(function(d) {
            const bbox = this.getBBox();
            const scale = Math.min(arc2.outerRadius()(d) - arc2.innerRadius()(d) / bbox.width, arc2.outerRadius()(d) - arc2.innerRadius()(d) / bbox.height);
            d.scale = scale > 1 ? 1 : scale;
          })
          .attr("class", "segmentpartText wantWeAreText")
          .style("font-size", d => d.scale * 10 + "px")
          .attr("dy", ".35em");
    },
    updatePercentTimeLeft() {
      if(this.votingInProgress == true){
        if(this.$refs['divider'] != undefined && this.dividerDivWidth == null){
          this.dividerDivWidth = this.$refs['divider']['offsetWidth'];
          this.buttonWidth = this.$refs['dividerButton']['offsetWidth'];
          this.buttonWidthFrom = this.dividerDivWidth/2-this.buttonWidth/2;
          this.buttonWidthTo = this.dividerDivWidth/2+this.buttonWidth/2;
        }
        const startTime = this.activeVoringStart;
        const endTime = this.activeVoringEnd;

        // eslint-disable-next-line no-unused-vars
        const now = Date.now();
        if (now >= endTime) {
          console.log("now", now)
          console.log("endTime", endTime)
          this.percentTimeLeft = 100;
          this.stopVoting(); // Stoppt den Timer, wenn die Endzeit erreicht ist
        } else {
          const elapsed = now - startTime;
          const total = endTime - startTime;
          const timeLeft = parseInt((endTime - now)/1000);
          let minutes = Math.floor(timeLeft / 60)
          let seconds = timeLeft % 60
          let displayString = `${minutes < 10 ? '0' : ''}${minutes}:${
              seconds < 10 ? '0' : ''
          }${seconds}`
          this.timeString = displayString;
          this.percentTimeLeft = 100 - ((elapsed / total) * 100);
          const pixelLeft = this.dividerDivWidth*this.percentTimeLeft/100;

          let buttonPercentTimeLeft = 100;
          if(pixelLeft>this.buttonWidthTo){
            buttonPercentTimeLeft = 100;
          } else if(pixelLeft< this.buttonWidthFrom) {
            buttonPercentTimeLeft = 0;
          } else {
            buttonPercentTimeLeft = 100-((this.buttonWidthTo-pixelLeft)*100/this.buttonWidth);
          }
          // Aktualisiert die CSS-Variable, wenn benötigt
          document.documentElement.style.setProperty('--divider-gradient-percentage', `${this.percentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-button-gradient-percentage', `${buttonPercentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-color', this.lightenDarkenColor(this.selectedSegment.data.color, -30));
        }
      }
    },
  }
};
</script>

<style>
.workshopSunBurst {
  overflow-y: hidden;
  max-height: 800vh;
}

:root {
  --divider-gradient-percentage: 0%; /* Standardwert */
  --divider-button-gradient-percentage: 0%; /* Standardwert */
  --divider-color: blue; /* Standardwert */
}
.container {
}
.svgContainer,
.detailContainer{
  position: relative;
  /*position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);*/
  width: 48%;
  margin: auto;
  display:inline-block;
  height: calc(100vh - 100px);
}
.chart{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 80px 80px;
  height: 90vh;
}
.svgDetailContainer{
  display: flex;
  margin-top: -40px;
  margin-bottom: -48px;
}
.detailCard{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 20px;
  max-height: 850px;
  width: 80%;
}
.detailContainer {
}
.svgContainer svg{
  height: 100%;
  overflow: visible;
}
.configContainer{
  position: absolute;
  top: 0;
  right: 0;
  display:inline-block;
  width: 50%;
  overflow-y: scroll;
  height: 100vh;
  max-height: 100vh;

}

.categorie {
  margin: 10px;
}

.subcategorie {
  margin: 5px 0;
}
.subcategorie .name {
  width: 250px;
  display: inline-block;
}
 .button {
   align-items: center;
   background-color: #efefef;
   border-radius: 8px;
   border: 1px solid #c0bfbf;
   box-shadow: rgba(255, 255, 255, 0.26) 0 1px 2px inset;
   box-sizing: border-box;
   color: #000;
   cursor: pointer;
   display: inline-block;
   flex-direction: row;
   flex-shrink: 0;
   font-family: "RM Neue",sans-serif;
   font-size: 100%;
   line-height: 1.0;
   margin: 0 5px;
   padding: 5px 21px;
   text-align: center;
   text-transform: none;
   transition: color .13s ease-in-out,background .13s ease-in-out,opacity .13s ease-in-out,box-shadow .13s ease-in-out;
   user-select: none;
   -webkit-user-select: none;
   touch-action: manipulation;
 }

.button.active {
  background-color: #a2a2a2;
  border: 1px solid #7a7a7a;
}

.button:hover {
  background-color: #e3e3e3;
  border: 1px solid #b7b7b7;
}
@keyframes pulse {
  0% {
    stroke-width: 4px;
    stroke-opacity: 1;
  }
  50% {
    stroke-width: 8px;
    stroke-opacity: 0.5;
  }
  100% {
    stroke-width: 4px;
    stroke-opacity: 1;
  }
}
.selected {
  animation: pulse 1.5s infinite;
}
.segmentpart,
.segmentpartText{
  cursor: pointer;
}
.actionButton {
  position: absolute;
  top: 20px;
  right: 20px;
}
.qrcode {
  margin: 20px auto;
}
.openLink {
  display: block;
  text-align: center;
  text-decoration: none;
  color: black;
  font-size: 20px;
  margin: 6px;
}
.usersButton {
  position: absolute;
  top: 20px;
  right: 85px;
}
.filterButton {
  position: absolute;
  top: 85px;
  right: 20px;
}
.startButton,
.stopButton {
  position: absolute;
  top: 20px;
  right: 20px;
}
.qrButton {
  position: absolute;
  top: 85px;
  right: 85px;
}
.detailCardContainer {
  margin: 10px 20px;
}


.card {
  z-index: 2;
  flex: 0 0 auto;
  width: 175px;
  height: 300px;
  margin: 10px;
  scroll-snap-align: start; /* Sorgt dafür, dass die Karten am Anfang des Containers einrasten */
  border-width: 2px;
  transition: all 1s linear;

}
.selected-card {
  border: #c7c7c7;
  background-color: #E0E0E0;
}
.card-headline, .card-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card-headline{
  font-size: 44px;
  height: calc(30% - 20px);
}
.card-divider{
  text-align: center;
  height: 4px;
  background: #e7e7e7;
  margin: 5px 18px;
}
.card-text{
  font-size: 14px;
  line-height: 16px;
  height: calc(60% - 20px);
}
.card-vote{
  text-align: center;
  font-size: 20px;
  line-height: 23px;
  margin-top: -10px
}
.card-vote .number{
  font-size: 20px;
  margin-bottom: 10px;
}
.cards-row {
  display: flex;
  flex-wrap: nowrap; /* Verhindert das Umbrechen der Karten */
  justify-content: center;
  overflow-x: auto;
  scroll-snap-type: x mandatory; /* Aktiviert Scroll Snapping für horizontales Scrollen */
  -webkit-overflow-scrolling: touch; /* Verbessert das Scrollen auf WebKit-basierten Browsern */
  margin: 0px 10px;
}
/* Der Scrollbalken selbst */
.cards-row::-webkit-scrollbar {
  height: 4px;
  border-radius: 5px;
  width: 6px; /* Breite des Scrollbalkens */
}

/* Der Hintergrund des Scrollbalkens (Track) */
.cards-row::-webkit-scrollbar-track {
  background: #f1f1f1; /* Farbe des Hintergrunds */
}

/* Der bewegbare Teil des Scrollbalkens (Thumb) */
.cards-row::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #888; /* Farbe des bewegbaren Teils */
}

/* Der bewegbare Teil des Scrollbalkens beim Hover */
.cards-row::-webkit-scrollbar-thumb:hover {
  background: #555; /* Farbe beim Hover */
}
.detailButtons {
  margin: 10px 0px;
  display: flex;
  justify-content: right;
}
.detailButtons .v-btn{
  margin-left: 20px;
}


.divider-area {
  position: relative;
  transition: background 1s linear;
  background: linear-gradient(to right, var(--divider-color) var(--divider-gradient-percentage), gray var(--divider-gradient-percentage));
  height: 4px;
  border-radius: 2px;
  cursor: pointer;
  margin: 25px 0px;
}
.divider-button-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  cursor: pointer;
  width: 100px;
  transition: background 1s linear;
  background: linear-gradient(to right, var(--divider-color) var(--divider-button-gradient-percentage), gray var(--divider-button-gradient-percentage));
  border-radius: 25px;
  padding: 4px; /* Abstand für den "Rand" */
  z-index: 10;

}

.divider-button {
  cursor: default;
  display: inline-block;
  background-color: white; /* Oder eine andere Hintergrundfarbe */
  border: none; /* Entfernt den Standardrand */
  width: 92px;
  border-radius: 25px; /* Stellen Sie sicher, dass dies kleiner als der Container-border-radius ist, falls verwendet */
}


.showAll .wantWeAreText {
  opacity: 0;
}
.showWhereWeAre .segmentpart{
  display: none;
}
.showWhereWeAre .segmentLinePart{
  fill-opacity: 1;
  stroke-opacity: 0;
}
.showWhereWeAre .wantWeWantToBeText {
  opacity: 0;
}
.showWhereWeAre .wantWeAreText {
  opacity: 1;
}
.showWhereWeWantToBe .segmentLinePart{
  display: none;
}
.showWhereWeWantToBe .wantWeAreText {
  opacity: 0;
}
.titleCardContainer{
  text-align: center;
  font-weight: bold;
}


</style>
